<template>
  <div class="flex">
    <div>
      <v-alert type="success" v-if="tecnicoAsignated">
        Equipos asignados a tecnico exitosamente</v-alert
      >
      <v-alert type="error" v-if="errormessage">
        No se pudo cargar el registro , intente mas tarde</v-alert
      >
    </div>
    <div class="justify-center">
      <v-container>
        <v-row class="flex-column">
          <v-card>
            <v-card-title>
              <span class="text-h5">Asignar Equipos</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      :items="namesObject"
                      v-model="tecnico"
                      label="Técnico"
                      :value="idusuario[namesObject.indexOf(tecnico)]"                  
                      dense
                      @change="tecnicoAsignated=false"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      :items="empresas"
                      v-model="empresa"
                      label="Empresa"
                      :value="selectedEmpresa"                     
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="mac"
                      label="MAC"                      
                    ></v-text-field>
                    <v-btn color="blue darken-1" text @click="asignar" :disabled="mac === ''"> Asignar</v-btn>
                  </v-col>
                   <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="drops"
                      label="Drops"  
                      type="number"                    
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="conectores"
                      label="Conectores" 
                      type="number"                     
                    ></v-text-field>                   
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-simple-table
                    fixed-header
                    height="400px">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              N°
                            </th>
                            <th class="text-left">
                              Routers
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in macAsignados" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                 
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text >
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
        <v-row>
         
        </v-row>
      </v-container>
    </div>
  </div>
</template>
  
  <script>
// import EquipoStore from "../store/index";
import { mapState } from "vuex";
import { addRouters } from "../database.js";

export default {
  name: "EquiposView",

  components: {},
  data() {
    return {
      selected: null,
      tecnico:"",
      empresa:"",
      selectedEmpresa: null,
      tecnicoAsignated: false,
      errormessage: false,
      mac:"",  
      macAsignados: [], 
      namesObject: [], 
      conectores:null,
      drops:null,
      items: [
        "Administrador",
        "Técnico Optix",
        "Técnico Westnet",
        "Técnico Bigway",
      ],
      empresas:  [
      { value: "westnet", text: "Westnet" },
      { value: "optix", text: "Optix" },
      { value: "bitway", text: "Bigway" },
    ],
      routers:{
        num:0,
        mac:""
      },
      idusuario:"",
      idusuarioSelected:"",
      date: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
      ).toLocaleDateString(),
    //   toSend: {
    //   num_router: "",
    //   num_cliente: "",
    //   num_ticket: "",
    //   metros_drop: "",
    //   conectores: "",
    //   asignado: "",
    //   fecha_asignacion: "",
    //   fecha_instalacion: "",
    //   tipo: "",
    //   estado: "LIBRE",
    //   id: "",
    //   idusuario:""      
    // },
     
    };
  },
  computed: {
    ...mapState({
      userlist: (state) => state.usersList,
      tecnicosName: (state) => state.tecnicosName,
      newuserdata: (state) => state.newuser,
      idnewuser: (state) => state.idnewuser,
      idtecnico: (state) => state.idtecnico,
    }),
  },
  created() {
    this.arrayToObject()
  },
  methods: {
    asignar(){
      this.macAsignados.push(this.mac);
      this.mac="";
      console.log(this.macAsignados)
    },
    arrayToObject() {
     const names = this.tecnicosName;
     this.namesObject = names.map(user => user.nombre);
     this.idusuario = names.map(user => user.id);
     
    },
    async save() {
      this.idusuarioSelected = this.idusuario[this.namesObject.indexOf(this.tecnico)];
      console.log("selectedempresa", this.selectedEmpresa)
      this.$store.commit('SET_COLLECTION', this.empresa)
      // console.log(this.toSend.idusuario)
      const toSendArray = [];

      this.macAsignados.forEach(num_router => {
        const toSendItem = {
          num_router: num_router,
          num_cliente: "",
          num_ticket: "",
          metros_drop: this.drops,
          conectores: this.conectores,
          asignado: this.tecnico,
          fecha_asignacion: this.date,
          fecha_instalacion: "",
          tipo: "",
          estado: "LIBRE",
          id: "",
          idusuario: this.idusuarioSelected      
        };
        toSendArray.push(toSendItem);
      });
      this.$store.commit('SET_ROUTERS', toSendArray)

      console.log(toSendArray);
      
      //dame un then y cath para la funcion addRouters()
      // await addRouters()
      // .then((res) => {
      //   console.log(res)
      //   this.tecnicoAsignated = true;
      // this.tecnico= ""
      // this.empresa=""
      // this.mac=""
      // this.macAsignados=[]
      // this.conectores= null
      // this.drops= null
      // })

     try{
      const res = await addRouters()
      console.log(res)
      this.tecnicoAsignated = true;
      this.tecnico= ""
      this.empresa=""
      this.mac=""
      this.macAsignados=[]
      this.conectores= null
      this.drops= null      
    }
    catch(err){
      console.log(err)
      this.errormessage = true
    }
    },
   
  },
};
</script>